{
  "kind": {
    "ssh": "терминал",
    "rdp": "удалённый рабочий стол",
    "vnc": "консоль"
  },
  "state": {
    "connecting": "Подключаемся…",
    "connected": "Подключено",
    "disconnected": "Отключено",
    "error": "Ошибка"
  },
  "tabsLabel": "Сеансы",
  "phoneButton": "Сеансы ({{count}})",
  "tabName": "{{name}}, {{kind}}: {{status}}",
  "tabNameUnseen": "{{name}}, {{kind}}: {{status}}, новый вывод",
  "unseen": "Новый вывод",
  "minimised": "свёрнут",
  "close": "Закрыть {{name}}",
  "moveHint": "Ctrl+Shift+стрелка влево или вправо переставляет вкладку; правая кнопка мыши — меню вкладки.",
  "moved": "{{name}}: место {{position}} из {{count}}",
  "menu": {
    "moveLeft": "Переместить влево",
    "moveRight": "Переместить вправо",
    "serverPage": "Открыть страницу сервера",
    "closeOthers": "Закрыть другие"
  },
  "toolbar": "Управление сеансом",
  "toServer": "Открыть страницу сервера {{name}}",
  "zones": {
    "session": "Сеанс",
    "tools": "Инструменты",
    "window": "Окно"
  },
  "tools": {
    "keyboard": "Клавиатура",
    "typeText": "Набрать текст",
    "paste": "Вставить из буфера",
    "combos": "Сочетания клавиш",
    "fit": "Вписать",
    "actual": "1:1",
    "settings": "Настройки сеанса",
    "reconnect": "Переподключиться",
    "disconnect": "Отключиться",
    "fullscreen": "Полный экран",
    "exitFullscreen": "Выйти из полного экрана",
    "minimise": "Свернуть во вкладку"
  },
  "reconnect": {
    "title": "Переподключиться к {{name}}?",
    "ssh": "Текущий сеанс будет закрыт: запущенные в нём программы завершатся.",
    "vnc": "Консоль переподключится.",
    "rdp": "Сеанс рабочего стола переподключится, пароль понадобится снова."
  },
  "restored": {
    "title": "Введите пароль, чтобы переподключиться",
    "ssh": "Страница перезагрузилась. Этот терминал входил по паролю, а пароли не сохраняются — введите его снова.",
    "rdp": "Страница перезагрузилась. Пароль Windows не сохраняется — введите его снова."
  },
  "gone": {
    "title": "Сервер не найден",
    "text": "Сервера {{name}} больше нет, или у вас больше нет доступа к его проекту. Закройте вкладку.",
    "close": "Закрыть вкладку"
  },
  "power": {
    "menu": "Питание",
    "powerOn": "Включить",
    "shutdown": "Выключить",
    "powerOff": "Выключить питание",
    "reboot": "Перезагрузить",
    "rebootHint": "Мягкая перезагрузка: если система зависла, используйте «Жёсткий перезапуск»",
    "reset": "Жёсткий перезапуск"
  },
  "combos": {
    "send": "Отправить {{keys}}"
  },
  "typeText": {
    "desktop": "Каждый символ будет набран на рабочем столе клавишами. Enter нажмёте вы — или отметьте ниже."
  },
  "pasteFailed": "Браузер не дал прочитать буфер обмена. Вставьте текст в поле сами.",
  "problem": "Не удалось открыть сеанс",
  "workspace": {
    "title": "Сеансы",
    "titleOf": "Сеанс {{name}}",
    "emptyTitle": "Нет открытых сеансов",
    "emptyText": "Подключитесь к серверу: терминал, рабочий стол или консоль откроются здесь и будут работать, пока вы ходите по панели."
  },
  "insert": {
    "into": "Вставить в текущую сессию {{name}}",
    "hint": "Команда появится в открытом сеансе; Enter нажмёте вы, когда прочитаете её.",
    "newTerminal": "Открыть новый терминал",
    "newConsole": "Открыть новую консоль"
  },
  "settings": {
    "title": "Настройки сеанса",
    "vncLead": "На какой раскладке набирать текст. Для всех консолей в этом браузере.",
    "rdpLead": "Какую раскладку клавиатуры ждёт Windows. Для всех рабочих столов в этом браузере.",
    "layout": "Раскладка клавиатуры",
    "console": {
      "us": "Английская (US)",
      "usHint": "Как у консоли Hetzner по умолчанию",
      "ru": "Русская (ЙЦУКЕН)",
      "ruHint": "Если на сервере включена русская раскладка: русские буквы наберутся, латинские — нет"
    },
    "rdp": {
      "default": "Как у шлюза (английская US)",
      "en-us-qwerty": "Английская (US)",
      "en-gb-qwerty": "Английская (Великобритания)",
      "de-de-qwertz": "Немецкая",
      "fr-fr-azerty": "Французская",
      "it-it-qwerty": "Итальянская",
      "es-es-qwerty": "Испанская",
      "sv-se-qwerty": "Шведская",
      "ja-jp-qwerty": "Японская",
      "failsafe": "Универсальная (Unicode, в том числе русская)"
    },
    "rdpLayoutHint": "Раскладка применяется при следующем входе: переподключитесь."
  },
  "pair": {
    "on": "Автопилот имеет доступ к сеансу",
    "running": "Автопилот выполняет: {{command}}",
    "access": "Автопилот имеет доступ к терминалу: {{level}}"
  }
}
